import fr from './i18n/locales/fr.json'
import en from './i18n/locales/en.json'
// import de from './i18n/locales/de.json'

export default defineI18nConfig(() => ({
    locale: 'fr',
    fallbackLocale: 'fr',
    locales: [
        {
            code: 'fr',
            iso: 'fr-FR',
            name: 'Français',
            file: 'fr.json'
        },
        {
            code: 'en',
            iso: 'en-US',
            name: 'English',
            file: 'en.json'
        },
        // {
        //     code: 'de',
        //     iso: 'de-DE',
        //     name: 'Deutsch',
        //     file: 'de.json'
        // }
    ],
    defaultLocale: 'fr',
    numberFormats: {
        fr: {
            currency: {
                style: 'currency',
                currency: 'XAF',
                notation: 'standard'
            },
            decimal: {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            },
            percent: {
                style: 'percent',
                useGrouping: false
            }
        },
        en: {
            currency: {
                style: 'currency',
                currency: 'XAF',
                notation: 'standard'
            },
            decimal: {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            },
            percent: {
                style: 'percent',
                useGrouping: false
            }
        }
    },
    datetimeFormats: {
        fr: {
            short: {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            },
            long: {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                weekday: 'short',
                hour: 'numeric',
                minute: 'numeric'
            }
        },
        en: {
            short: {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            },
            long: {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                weekday: 'short',
                hour: 'numeric',
                minute: 'numeric'
            }
        }
    },
    messages: {
        fr,
        en,
        // de
    }
}))